import {
  addPlainDays,
  comparePlainDates,
  plainDateRange,
  type PlainDateRange,
} from '@shiftbase-com/ts-shared/utilities';

/** `ListRequest::MAX_DAYS` — the priority endpoint rejects a wider request. */
export const PRIORITY_MAX_DAYS = 31;

export function splitIntoPriorityWindows(range: PlainDateRange): PlainDateRange[] {
  if (comparePlainDates(range.start, range.end) > 0) {
    return [];
  }

  const windows: PlainDateRange[] = [];
  let windowStart = range.start;

  while (comparePlainDates(windowStart, range.end) <= 0) {
    const cappedEnd = addPlainDays(windowStart, PRIORITY_MAX_DAYS - 1);
    const windowEnd = comparePlainDates(cappedEnd, range.end) > 0 ? range.end : cappedEnd;

    windows.push(plainDateRange(windowStart, windowEnd));
    windowStart = addPlainDays(windowEnd, 1);
  }

  return windows;
}
